module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "el-zoom-in-top"
    }
  }, [_c('div', {
    staticClass: "content-wrapper"
  }, [_c('section', {
    staticClass: "content-header"
  }), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body",
    staticStyle: {
      "min-height": "400px"
    }
  }, [_c('h3', [_c('strong', [_vm._v("Settings")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-9"
  }, [_c('a', {
    attrs: {
      "href": '#/userProfile/' + this.userId + '/update'
    }
  }, [_c('h5', {
    staticStyle: {
      "text-align": "left"
    },
    attrs: {
      "for": "inputPassword"
    }
  }, [_vm._v("Update Profile")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "left",
      "font-size": "9pt"
    },
    attrs: {
      "id": "inputPassword"
    }
  }, [_vm._v("Update your user profile information.")])])])]), _vm._v(" "), _c('div', [_c('hr'), _vm._v(" "), _c('button', {
    staticStyle: {
      "background": "none",
      "border": "none"
    },
    on: {
      "click": _vm.deleteProfile
    }
  }, [_c('h5', {
    staticStyle: {
      "text-align": "left",
      "color": "red"
    },
    attrs: {
      "for": "inputPassword"
    }
  }, [_vm._v("Delete Profile")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "left",
      "font-size": "9pt"
    }
  }, [_vm._v("Delete your user profile.")])]), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 row-block"
  }, [_c('a', {
    staticClass: "btn btn-primary btn-block",
    attrs: {
      "href": "#/"
    }
  }, [_vm._v("Go Back to Main Page")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-746e1eec!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Settings.vue
// module id = 1309
// module chunks = 2